export const QuizCustomNode = ({componentName, components, metaData, onRespond}: QuizCustomNodeType): JSX.Element => {
    console.log(components);
    const ComponentToRender = components[componentName];
    return <ComponentToRender metaData={metaData} onRespond={onRespond}/>
}

export type customNodeType = {
    metaData?: any
    onRespond?: (val: string) => void
}

type QuizCustomNodeType = customNodeType & {
    componentName: string
    components: Record<string, any>

}